// removed by extract-text-webpack-plugin
module.exports = {"headerTop":"_1bGKPl3d1e6k6NZxhGefEf","headerBack":"_3J-waag_oKoDthTEL8Is_F","headerLogoTop":"RTyFxUHdAdUgceA5-XLZF","headerGymsTop":"_8_8sC4O9V0WJ7-_vRf7lF"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/NewHeader/NewHeader.scss
 ** module id = 997
 ** module chunks = 0
 **/